import BlockTextImage from './block-text-image';

export default class BlockTextImageDesktop extends BlockTextImage {
    constructor(...args) {
        super(...args);
    }

    /*
    init() {
    }
    bind() {
    }
    unbind() {
    }
    resize(width, height) {
    }
    */
}



// WEBPACK FOOTER //
// ./src/js/components/block-text-image/block-text-image.desktop.js